import React, { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { App } from '@capacitor/app';
import { PushNotifications } from '@capacitor/push-notifications';

const MobileWrapper = ({ children }) => {
  useEffect(() => {
    const listenerPromises = [];

    const initializeMobile = async () => {
      if (Capacitor.isNativePlatform()) {
        try {
          const platform = Capacitor.getPlatform();

          // Configure status bar
          await StatusBar.setStyle({ style: Style.Dark });
          await StatusBar.setBackgroundColor({ color: '#0d6efd' });
          
          // Hide splash screen after app is ready
          await SplashScreen.hide();
          
          // Handle app state changes
          listenerPromises.push(App.addListener('appStateChange', ({ isActive }) => {
            console.log('App state changed. Is active?', isActive);
          }));
          
          listenerPromises.push(App.addListener('appUrlOpen', (data) => {
            console.log('App opened with URL:', data.url);
          }));

          if (platform === 'ios') {
            listenerPromises.push(PushNotifications.addListener('registration', (token) => {
              console.log('Push registration succeeded:', token.value);
            }));

            listenerPromises.push(PushNotifications.addListener('registrationError', (error) => {
              console.error('Push registration failed:', error);
            }));

            listenerPromises.push(PushNotifications.addListener('pushNotificationReceived', (notification) => {
              console.log('Push notification received:', notification);
            }));

            listenerPromises.push(PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
              console.log('Push notification action performed:', notification);
            }));

            let permissionStatus = await PushNotifications.checkPermissions();
            if (permissionStatus.receive === 'prompt') {
              permissionStatus = await PushNotifications.requestPermissions();
            }

            if (permissionStatus.receive === 'granted') {
              await PushNotifications.register();
            } else {
              console.warn('Push notification permission was not granted.');
            }
          }
        } catch (error) {
          console.error('Error initializing mobile features:', error);
        }
      }
    };

    initializeMobile();

    return () => {
      Promise.allSettled(listenerPromises).then((results) => {
        results.forEach((result) => {
          if (result.status === 'fulfilled') {
            result.value.remove();
          }
        });
      });
    };
  }, []);

  return <>{children}</>;
};

export default MobileWrapper;
